import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomeComponent } from './views/welcome/welcome.component';
import { CanActivateAuthentication } from './views/authentication/authentication-can-activate.guard';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      { path: 'welcome',
        component: WelcomeComponent,
        canActivate: [CanActivateAuthentication],
        data: {
          title: 'Welcome'
        }
      },
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'best',
        loadChildren: './views/best-rates/best-rates.module#BestRatesModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'upload-cdr-files/:importType',
        loadChildren: './views/upload-cdr-file/upload-cdr-file.module#UploadCdrFileModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'user',
        loadChildren: './views/authentication/authentication.module#AuthenticationModule'
      },
      {
        path: 'details',
        loadChildren: './views/charge-details/charge-details.module#ChargeDetailsModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'details-lines',
        loadChildren: './views/details_lines/details_lines.module#DetailsLinesModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'hr',
        loadChildren: './views/human-resources/human-resources.module#HumanResourcesModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'personal-spent',
        loadChildren: './views/details-personal-spent/details-personal-spent.module#DetailsPersonalSpentModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'top-roaming',
        loadChildren: './views/top-roaming/top-roaming.module#TopRoamingModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'top-data',
        loadChildren: './views/top-data/top-data.module#TopDataModule',
        canActivate: [CanActivateAuthentication]
      },
      /*{
        path: 'wizard',
        loadChildren: './views/chart-wizard/chart-wizard.module#ChartWizardModule',
        canActivate: [CanActivateAuthentication]
      },*/
      {
        path: 'detailsTA',
        loadChildren: './views/details-totalAccount/details-totalAccount.module#detailsTotalAccountModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'plans-linesInt',
        loadChildren: './views/lines-intelligence/lines-intelligence.module#LinesIntelligenceModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'detailsNL',
        loadChildren: './views/details-number-lines/details-number-lines.module#detailsNumberLinesModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'renewal',
        loadChildren: './views/renewal-lines/renewal-lines.module#renewalLinesModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'contract',
        loadChildren: './views/contract-lines/contract-lines.module#contractLinesModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'optimization-graph',
        loadChildren: './views/optimization-graph/optimization-graph.module#OptimizationGraphModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'tags-strategy-selector',
        loadChildren: './views/tags-strategy-selector/tags-strategy-selector.module#TagsStrategySelectorModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'total-graph',
        loadChildren: './views/total-graph/total-graph.module#TotalGraphModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'statistics',
        loadChildren: './views/statistics/statistics.module#StatisticsModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'plan-stat',
        loadChildren: './views/plan-statistics/plan-statistics.module#PlanStatisticsModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'cdr-status',
        loadChildren: './views/cdr-files-table/cdr-files-table.module#CdrFilesTableModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'payment-form',
        loadChildren: './views/payment-form/payment-form.module#PaymentFormModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'payed-months',
        loadChildren: './views/payed-months/payed-months.module#PayedMonthsModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'optimization-document',
        loadChildren: './views/optimization-pdf-deliverable/optimization-pdf-deliverable.module#OptimizationDeliverableModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'locations',
        loadChildren: './views/locations-map/locations-map.module#LocationsMapModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'overview-lines',
        loadChildren: './views/locationsG/locationsG.module#LocationsGModule',
        canActivate: [CanActivateAuthentication]
      },
      {
        path: 'menuAdmin',
        loadChildren: './views/menu-admin/menu-admin.module#MenuAdminModule',
        canActivate: [CanActivateAuthentication]
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts